<template>
  <div class="pd-segments-comp">
    <RfPromoDetailsInfoRow title="Segments">
      <template #promodetail>
        <div v-if="path.sequence_id">
          Inherited from <router-link :to="sequenceLink">{{ path.sequence_name }}</router-link>
        </div>
        <div v-else-if="segments.length > 0 && !path.sequence_id" style="margin-left: -5px">
          <router-link
            v-for="segment in [...segments].sort((a, b) => `${a.name}`.localeCompare(`${b.name}`))"
            :key="segment.name"
            :to="segmentLink(segment.id)"
            class="pd-segments-comp--segments-link"
          >
            {{ segment.name }}
            <RfSegmentBucketRange
              class="segment-bucket-range"
              :showWarning="segments.length > 1"
              :bucketRange="bucketRange(segment)"
            />
          </router-link>
        </div>
        <div v-else class="empty-segments-info">N/A</div>
        <div v-if="!path.sequence_id" class="pd-info-edit pd-info-edit--segment">
          <RfButton
            iconSize="16"
            title="edit"
            icon="md:edit"
            color="accent"
            size="x-small"
            variant="text"
            :disabled="editDisabled"
            @click="showPromoDetailDialog"
          />
        </div>
      </template>
    </RfPromoDetailsInfoRow>
    <RfLinkedSegments ref="linkedSegments" :model="path" @confirm="submitConfiguration" />
  </div>
</template>

<script>
import RfPromoDetailsInfoRow from "@/components/RfPromotions/RfPromoDetailsInfoRow.vue";
import RfLinkedSegments from "@/components/RfPathCreate/RfLinkedSegments.vue";
import RfSegmentBucketRange from "@/components/RfSegments/RfSegmentBucketRange.vue";
import RfButton from "@/components/buttons/RfButton.vue";
import { useToastsStore } from "@/pinia/toastsStore";
import { useSequencesStore } from "@/pinia/sequencesStore";
import { usePromptStore } from "@/pinia/promptStore";
import { segmentItemFor, displayBucketRange } from "@/utils/segmentsHelpers";

export default {
  name: "RfPromoSegmentsInfo",
  components: { RfPromoDetailsInfoRow, RfLinkedSegments, RfSegmentBucketRange, RfButton },
  props: ["path", "editDisabled", "pathGroupDisplay"],
  setup: () => ({
    toastsStore: useToastsStore(),
    sequencesStore: useSequencesStore(),
    promptStore: usePromptStore(),
  }),
  computed: {
    sequenceLink() {
      return { path: `/apps/${this.$route.params.aid}/experiences/${this.path.sequence_id}` };
    },
    segments() {
      return this.path.segments || [];
    },
  },
  methods: {
    segmentLink(segmentId) {
      return { path: `/apps/${this.$route.params.aid}/segments/${segmentId}` };
    },
    showPromoDetailDialog() {
      this.$refs.linkedSegments.open();
    },
    async submitConfiguration(newPath) {
      try {
        const appId = this.$route.params.aid;
        await this.sequencesStore.updateSequence({
          appId,
          sequenceId: this.path.id,
          modelSequence: newPath,
        });
        this.toastsStore.create({ type: "success", body: "Guide updated successfully" });
      } catch (e) {
        this.toastsStore.create({ type: "error", body: e.message });
      }
    },
    bucketRange(segment) {
      return displayBucketRange(segmentItemFor(segment, this.path));
    },
  },
};
</script>

<style lang="scss" scoped>
.segment-bucket-range {
  &:before {
    content: " ( ";
  }
  &:after {
    content: " ) ";
  }
}
</style>
